import { useParams, useNavigate, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import { FadeUp } from "../components/site/Reveal";
import { LEGAL_DOCS } from "../data/content";

export default function LegalDoc() {
    const { docId } = useParams();
    const navigate = useNavigate();
    const doc = LEGAL_DOCS[docId];

    if (!doc) return <Navigate to="/" replace />;

    return (
        <div className="grain bg-navy-deep" data-testid="legal-doc-page">
            <Header />
            <main>
                <section className="bg-ivory pb-24 pt-[76px] text-navy-deep lg:pb-32">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <FadeUp>
                            <button
                                type="button"
                                data-testid="legal-back-button"
                                onClick={() => navigate("/")}
                                className="mt-10 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-navy-deep/60 transition-colors hover:text-gold"
                            >
                                <ArrowLeft size={14} />
                                Back to Homepage
                            </button>
                        </FadeUp>

                        <div className="mt-12 max-w-3xl">
                            <FadeUp delay={0.05}>
                                <div className="flex items-center gap-4">
                                    <span className="h-px w-10 bg-gold" aria-hidden="true" />
                                    <span className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">
                                        Viet Medica Ltd — Legal
                                    </span>
                                </div>
                                <h1 className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl">
                                    {doc.title}
                                </h1>
                                {!doc.published && (
                                    <span
                                        className="mt-6 inline-block border border-gold/50 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.22em] text-navy-deep/60"
                                        data-testid="legal-draft-badge"
                                    >
                                        Being finalised — pending legal review
                                    </span>
                                )}
                            </FadeUp>
                            <FadeUp delay={0.15}>
                                <div className="mt-8 space-y-5 border-t border-navy-deep/10 pt-8">
                                    {doc.body.map((p, i) => (
                                        <p key={i} className="text-base leading-relaxed text-navy-deep/75 md:text-lg">
                                            {p}
                                        </p>
                                    ))}
                                </div>
                            </FadeUp>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
